module.exports = __webpack_public_path__ + "img/icon-points2.3daafd0d.png";